import React from 'react';
import CertficateImage from "../../assets/carousel/certi_img.png";

export default function Certification({certificateData}) {
  return (
    <>
        <div className='flex max-sm:block justify-center max-sm:space-y-6 gap-16 transition-all duration-500 ease-in-out'>
            {certificateData?.length > 0 && certificateData?.map((item,index) => {
              return (
                <div className='flex items-center gap-2'>
                  <img src={CertficateImage} className='w-14' alt={"certificate"} />
                  <div className='text-left'>
                    <p title={item?.title} className='font-semibold font-[TATAAIAPrint] w-full max-sm:w-full text-[#222] text-sm max-sm:text-base'>{item?.title?.slice(0, 25)}{ item?.title?.length > 25 ? "...":"" }</p>
                    <p title={ item?.description } className='font-normal font-[HelveticaNeueLTStd] text-[#757575] max-sm:text-sm text-xs'>{item?.description?.slice(0, 35)}{ item?.description?.length > 35 ? "...":"" }</p>
                  </div>
                </div>
              );
            })}
        </div>
    </>
  );
} 
